import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { memoizedSortScopesCategories } from '../../utils/sortScopesCategories';
import { memoizedCreateScopesTree } from '../../utils/createScopesTree';
import ScopeGroupList from './ScopeGroupList';
import ScopeGroupCategory from './ScopeGroupCategory';
import { GenericScopePropType } from '../../models/Scope';

const ScopesAuthorization = ({
  className,
  requestedScopes,
  sortedScopeCategories,
  defaultOpenFirstScope = true
}) => {
  const renderScopeCategories = () => {
    const scopesTree = memoizedCreateScopesTree(requestedScopes, false);

    if (!sortedScopeCategories) {
      sortedScopeCategories = memoizedSortScopesCategories(scopesTree);
    }

    if (sortedScopeCategories.length === 0) {
      return null;
    }

    return sortedScopeCategories.filter(({
      category
    }) => category in scopesTree).map(({
      category,
      isGranular
    }, ind) => {
      if (!isGranular) {
        return /*#__PURE__*/_jsx(ScopeGroupList, {
          category: category,
          scopes: scopesTree[category]
        }, category);
      }

      return /*#__PURE__*/_jsx(ScopeGroupCategory, {
        category: category,
        defaultOpen: defaultOpenFirstScope && ind === 0,
        scopes: scopesTree[category]
      }, category);
    });
  };

  return /*#__PURE__*/_jsx("div", {
    className: className,
    children: renderScopeCategories()
  });
};

ScopesAuthorization.propTypes = {
  className: PropTypes.string,

  /* Array of scopes. Recommended to use the Scope model from this library,
  but any Immutable.Record with the required values will work. */
  requestedScopes: GenericScopePropType.isRequired,

  /* Categories to render scopes under. Should be ordered in the order you want
  them to display. Categories marked as "granular" will combine read/write/etc.
  operations for the same scope into one row; those that are not will render
  one scope per line. The sortScopeCategories utility will provide the
  categories in the proper format. */
  sortedScopeCategories: PropTypes.arrayOf(PropTypes.shape({
    category: PropTypes.string.isRequired,
    isGranular: PropTypes.bool.isRequired
  }).isRequired)
};
export default ScopesAuthorization;